import type { HandoverApartment } from '@sivan/shared';

export function LoadingBlock() {
  return (
    <div className="skeleton" role="status" aria-label="טוען נתונים">
      {Array.from({ length: 5 }, (_, i) => (
        <div key={i} className="skeleton__row" />
      ))}
    </div>
  );
}

/**
 * A failure: what happened, one action (by default "נסו שוב"), and the request id for support
 * folded under "פרטים טכניים" instead of shown to every user.
 */
export function Problem({
  text,
  requestId,
  onRetry,
  actionLabel = 'נסו שוב',
}: {
  readonly text: string;
  readonly requestId?: string | null;
  readonly onRetry?: () => void;
  /** The action's label when it does not retry (for example "חזרה"). */
  readonly actionLabel?: string;
}) {
  return (
    <div className="notice notice--error" role="alert">
      <p>{text}</p>
      {onRetry !== undefined && (
        <button type="button" className="button" onClick={onRetry}>
          {actionLabel}
        </button>
      )}
      {requestId != null && (
        <details className="problem__details">
          <summary>פרטים טכניים</summary>
          <p className="hint">
            מזהה בקשה: <bdi dir="ltr">{requestId}</bdi>
          </p>
        </details>
      )}
    </div>
  );
}

export const apartmentTitle = (a: HandoverApartment) =>
  `דירה ${a.apartmentNumber} · בניין ${a.building}${a.floor === '' ? '' : ` · ${a.floor}`}`;
